import * as type from "./type";

const initialState = {
    getLinks: null,
    addLink: null,
    deleteInquiry: null,
};

const LinkReducer = (state = initialState, action) => {
    switch (action.type) {
        case type.GET_LINK_MANAGEMENT_REQUEST:
            return { ...state, getLinks: null };
        case type.GET_LINK_MANAGEMENT_SUCCESS:
            return { ...state, getLinks: action.payload };
        case type.ADD_LINK_REQUEST:
            return { ...state, addLink: null };
        case type.ADD_LINK_SUCCESS:
            return { ...state, addLink: action.payload };
        case type.STATUS_LINK_CHANGE_REQUEST:
            return { ...state, changeStatus: null };
        case type.STATUS_LINK_CHANGE_SUCCESS:
            return { ...state, changeStatus: action.payload };
        default:
            return state;
    }
};

export default LinkReducer;
